export const APPOINTMENT = Object.freeze({
  STATUS: {
    ACTIVE: 'ACTIVE',
    PENDING_APPROVAL_AND_ASSIGNMENT: 'PENDING_APPROVAL_AND_ASSIGNMENT',
    PENDING_ASSIGNMENT: 'PENDING_ASSIGNMENT',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    DENIED: 'DENIED',
    PENDING_HOST_ASSIGNMENT: 'PENDING_HOST_ASSIGNMENT',
    PENDING: 'PENDING'
  }
});

export const categories = Object.freeze({
  attendeeNetworking: 'ATTENDEE_NETWORKING',
  customAppointment: 'CUSTOM_APPOINTMENT',
  exhibitorNetworking: 'EXHIBITOR_NETWORKING',
  selfSignUp: 'SELF_SIGN_UP',
  personalTime: 'PERSONAL_TIME'
});

export const personalTypeApptType = 'PERSONAL_TIME';

export const TimeSlotTypes = Object.freeze({
  STANDARD: 'STANDARD',
  FREEFORM: 'ADHOC'
});

export const ATTENDEE_STATUS = Object.freeze({
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  TENTATIVE: 'tentative'
});

export const ENTITY_TYPE = Object.freeze({
  INVITEE: 'INVITEE',
  EXHIBITOR: 'EXHIBITOR'
});

export const SEND_TO = Object.freeze({
  all: 'all',
  changed: 'changed'
});

export const attendeeStatuses = Object.freeze({
  ACCEPTED: 'confirmed',
  DECLINED: 'cancelled',
  PENDING: 'pending',
  PENDING_PROPOSED: 'pending_proposed',
  TENTATIVE: 'tentative'
});

export const createTypes = Object.freeze({
  EXHIBITOR_FORM_WITH_AUTO_ASSIGN_STAFF: 'exhibitorFormWithAutoAssignStaff',
  EXHIBITOR_FORM_WITH_ANY_STAFF: 'exhibitorFormWithAnyStaff',
  EXHIBITOR_FORM_WITH_STAFF: 'exhibitorFormWithStaff',
  EXHIBITOR_BOOTH_STAFF_FORM: 'exhibitorBoothStaffForm',
  CUSTOM_APPT: 'customAppointment',
  CUSTOM_APPT_WITH_ANY_STAFF: 'customAppointmentWithAnyStaff',
  SELF_SCHEDULE_APPT: 'selfScheduleAppt',
  SELF_SCHEDULE_HOST_APPT: 'selfScheduleHostAppt',
  FREEFORM_APPT: 'freeformAppointment',
  FREEFORM_APPT_WITH_ANY_STAFF: 'freeformAppointmentWithAnyStaff'
});

export const ActionSource = Object.freeze({
  ATTENDEE_HUB_MOBILE_MY_SCHEDULE: 'ATTENDEE_HUB_MOBILE_MY_SCHEDULE',
  ATTENDEE_HUB_WEB_MY_SCHEDULE: 'ATTENDEE_HUB_WEB_MY_SCHEDULE',
  ATTENDEE_HUB_WEB_NOTIFICATION: 'ATTENDEE_HUB_WEB_NOTIFICATION',
  ATTENDEE_HUB_WEB_QUICK_RESPOND: 'ATTENDEE_HUB_WEB_QUICK_RESPOND'
});

export const attendeeRoles = Object.freeze({
  HOST: 'HOST',
  ATTENDEE: 'ATTENDEE'
});

export const PanelDisplayMode = Object.freeze({
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  CREATE: 'CREATE'
});

export const AnswerType = Object.freeze({
  TEXT: 'Text',
  CHOICE: 'Choice',
  OTHER: 'Other'
});

export const NO_LOCATION_ID = '00000000-0000-0000-0000-000000000000';
export const OTHER_VALUE_MARKER = 'other';

export const dialogKeys = Object.freeze({
  appointment: 'appointment',
  timeBlock: 'time-block'
});

export const appointmentFactOrigins = Object.freeze({
  MY_SCHEDULE_LIST_VIEW: 'My Schedule List View',
  APPOINTMENT_DETAILS_PANEL: 'Appointment Details Panel',
  APPOINTMENT_NOTIFICATION: 'Appointment Notification',
  ATTENDEE_LIST: 'Attendee List',
  ATTENDEE_PROFILE: 'Attendee Profile',
  EXHIBITOR_DETAIL_PAGE: 'Exhibitor Detail Page',
  CONNECTIONS_PAGE: 'Connections Page',
  HOME_PAGE: 'Home Page',
  MY_SCHEDULE_FLYOUT: 'My Schedule Flyout'
});

export const ddScheduleAppointmentActionName = 'Schedule appointment';
